var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConstructionBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9055 13.0506L13.7842 15.1719L19.7804 21.1681L21.9017 19.0468L15.9055 13.0506Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5006 10.0008C19.4306 10.0008 21.0006 8.43078 21.0006 6.50078C21.0006 5.92078 20.8406 5.38078 20.5906 4.90078L17.8906 7.60078L16.4006 6.11078L19.1006 3.41078C18.6206 3.16078 18.0806 3.00078 17.5006 3.00078C15.5706 3.00078 14.0006 4.57078 14.0006 6.50078C14.0006 6.91078 14.0806 7.30078 14.2106 7.66078L12.3606 9.51078L10.5806 7.73078L11.2906 7.02078L9.88059 5.61078L12.0006 3.49078C10.8306 2.32078 8.93059 2.32078 7.76059 3.49078L4.22059 7.03078L5.63059 8.44078H2.81059L2.10059 9.15078L5.64059 12.6908L6.35059 11.9808V9.15078L7.76059 10.5608L8.47059 9.85078L10.2506 11.6308L2.84059 19.0408L4.96059 21.1608L16.3406 9.79078C16.7006 9.92078 17.0906 10.0008 17.5006 10.0008Z",
    fill: "black",
    fillOpacity: 0.6
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConstructionBlack);
export default __webpack_public_path__ + "static/media/construction-black.42d31f738e754764214a58f2c1263e88.svg";
export { ForwardRef as ReactComponent };